import React, { useEffect, useState } from 'react';

const API = import.meta.env.VITE_API_URL;

export default function ServerStatus() {
  const [health, setHealth] = useState(null);
  const [stats, setStats] = useState(null);
  const [sessions, setSessions] = useState({ data: [], meta: { total: 0, limit: 50, offset: 0 } });
  const [loading, setLoading] = useState(true);

  const load = async (offset = 0) => {
    setLoading(true);
    try {
      const [h, s, a] = await Promise.all([
        fetch(`${API}/api/admin/server/health`).then(r => r.json()).catch(()=>null),
        fetch(`${API}/api/admin/sessions/stats`).then(r => r.json()).catch(()=>null),
        fetch(`${API}/api/admin/sessions/active?limit=50&offset=${offset}`).then(r => r.json()).catch(()=>({ data: [], meta: { total: 0, limit: 50, offset } })),
      ]);
      if (h) setHealth(h);
      if (s) setStats(s);
      if (a) setSessions(a);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(0); }, []);

  const invalidate = async (jti) => {
    if (!jti) return;
    try {
      await fetch(`${API}/api/admin/sessions/${jti}/invalidate`, { method: 'POST' });
      load(sessions.meta.offset);
    } catch {}
  };

  const fmt = (d) => d ? new Date(d).toLocaleString() : '';
  const fmtUptime = (s) => {
    const n = Math.max(0, Math.floor(Number(s || 0)));
    const h = Math.floor(n / 3600);
    const m = Math.floor((n % 3600) / 60);
    const sec = n % 60;
    if (h > 0) return `${h}h ${m}m ${sec}s`;
    if (m > 0) return `${m}m ${sec}s`;
    return `${sec}s`;
  };

  return (
    <div style={{ padding: '1rem' }}>
      <h2 style={{ marginBottom: 12 }}>Server Status</h2>
      {loading && <div>Loading…</div>}

      {health && (
        <div style={{ marginBottom: 16 }}>
          <h3>Health</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(200px, 1fr))', gap: 8 }}>
            <div>Uptime: {fmtUptime(health.uptimeSec)}</div>
            <div>Node: {health.node}</div>
            <div>RSS: {Math.round((health.rss || 0)/1024/1024)} MB</div>
            <div>Heap: {Math.round((health.heapUsed || 0)/1024/1024)}/{Math.round((health.heapTotal || 0)/1024/1024)} MB</div>
            <div>Load: {health.load1?.toFixed?.(2)} / {health.load5?.toFixed?.(2)} / {health.load15?.toFixed?.(2)}</div>
            <div>CPUs: {health.cpus}</div>
          </div>
        </div>
      )}

      {stats && (
        <div style={{ marginBottom: 16 }}>
          <h3>Sessions</h3>
          <div>Active Users: {stats.activeUsers} | Active Sessions: {stats.activeSessions} | Touches last 5m: {stats.touches5m}</div>
        </div>
      )}

      <div>
        <h3>Active Sessions</h3>
        <div style={{ overflow: 'auto' }}>
          <table className="orders-table" style={{ width: '100%', minWidth: 900 }}>
            <thead>
              <tr>
                <th>User</th>
                <th>Login</th>
                <th>Type</th>
                <th>Client</th>
                <th>IP</th>
                <th>User Agent</th>
                <th>Issued</th>
                <th>Last Seen</th>
                <th>Expires</th>
                <th>Requests</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
                {sessions.data.length ? sessions.data.map(r => (
                  <tr key={r.jti}>
                  <td>{r.userFullName || r.login || r.userid}</td>
                  <td>{r.login}</td>
                  <td>{(r.isclient === true || r.isclient === 1 || String(r.isclient).toLowerCase() === 'true' || String(r.isclient) === '1') ? 'Client' : 'Internal'}</td>
                  <td style={{ maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.clientnames || ''}</td>
                  <td>{r.ip}</td>
                  <td style={{ maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.useragent}</td>
                  <td>{fmt(r.issued_at)}</td>
                  <td>{fmt(r.last_seen_at)}</td>
                  <td>{fmt(r.expires_at)}</td>
                  <td>{r.requests}</td>
                  <td><button className="btn" onClick={() => invalidate(r.jti)}>Force Logout</button></td>
                </tr>
              )) : (
                <tr><td colSpan={11}>No active sessions.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
